export const GRANT_ACCESS_REQUEST = 'GRANT_ACCESS_REQUEST'
export const GRANT_ACCESS_SUCCESS = 'GRANT_ACCESS_SUCCESS'
export const GRANT_ACCESS_FAIL = 'GRANT_ACCESS_FAIL'
export const GRANT_ACCESS_RESET = 'GRANT_ACCESS_RESET'

export const GET_ACCESS_LIST_REQUEST = 'GET_ACCESS_LIST_REQUEST'
export const GET_ACCESS_LIST_SUCCESS = 'GET_ACCESS_LIST_SUCCESS'
export const GET_ACCESS_LIST_FAIL = 'GET_ACCESS_LIST_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'